import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2, Clock, CalendarDays, Printer } from "lucide-react";
import { format, parseISO } from "date-fns";
import { nl } from "date-fns/locale";
import { api } from "../lib/api";

export default function AgendaOverviewPage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/public/agenda/${token}`).then((r) => setData(r.data)).catch(() => setError(true));
  }, [token]);

  return (
    <div className="min-h-screen bg-[#FAF7F2] font-sans py-8 px-4">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-8">
          <div className="w-12 h-12 rounded-full bg-brand text-white flex items-center justify-center mx-auto mb-3 font-display">NH</div>
          <h1 className="text-2xl font-display">Agenda-overzicht</h1>
          <p className="text-ink-muted text-sm">Komende 7 dagen · alleen-lezen</p>
          {data && (
            <button onClick={() => window.print()} data-testid="print-agenda-btn"
              className="mt-3 inline-flex items-center gap-1.5 text-sm rounded-full border border-[#E8E2D9] bg-white px-4 py-2 hover:bg-cream-subtle transition-colors print:hidden">
              <Printer className="w-4 h-4" /> Print / PDF
            </button>
          )}
        </div>

        {error && <p className="text-center text-ink-muted text-sm py-10">Dit overzicht is niet (meer) beschikbaar.</p>}
        {!error && !data && <div className="text-center py-10"><Loader2 className="w-6 h-6 animate-spin text-brand mx-auto" /></div>}

        {data && (
          <div className="space-y-4">
            {data.days.map((day) => (
              <div key={day.date} data-testid={`agenda-day-${day.date}`} className="bg-white rounded-2xl border border-[#E8E2D9] overflow-hidden">
                <div className="px-5 py-3 border-b border-[#F2EBE1] flex items-center gap-2">
                  <CalendarDays className="w-4 h-4 text-brand" />
                  <span className="font-medium capitalize">{format(parseISO(day.date + "T00:00:00"), "EEEE d MMMM", { locale: nl })}</span>
                  <span className="text-ink-muted text-sm ml-auto">{day.items.length} {day.items.length === 1 ? "afspraak" : "afspraken"}</span>
                </div>
                {!day.items.length ? (
                  <div className="px-5 py-4 text-sm text-ink-muted">Geen afspraken.</div>
                ) : (
                  <div className="divide-y divide-[#F2EBE1]">
                    {day.items.map((a, i) => {
                      const pending = a.status === "reschedule_pending";
                      return (
                      <div key={i} className={`px-5 py-3 flex items-center gap-4 ${pending ? "bg-[#FBEBD2]" : ""}`}>
                        <div className={`flex items-center gap-1.5 text-sm font-medium w-24 shrink-0 ${pending ? "text-[#9A5B12]" : "text-brand"}`}>
                          <Clock className="w-3.5 h-3.5" />
                          {format(parseISO(a.start), "HH:mm")}{a.end ? `–${format(parseISO(a.end), "HH:mm")}` : ""}
                        </div>
                        <div className="min-w-0">
                          <div className="text-sm truncate flex items-center gap-2">
                            {a.treatment_name}
                            {pending && (
                              <span className="text-[10px] font-medium rounded-full bg-[#E0A24A]/20 text-[#9A5B12] border border-dashed border-[#E0A24A] px-2 py-0.5 whitespace-nowrap">
                                Verzetten aangevraagd
                              </span>
                            )}
                          </div>
                          <div className="text-xs text-ink-muted truncate">
                            {a.customer_name}
                            {pending && a.proposed_start && (
                              <span className="text-[#9A5B12]"> · voorstel: {format(parseISO(a.proposed_start), "EEE d MMM HH:mm", { locale: nl })}</span>
                            )}
                          </div>
                        </div>
                      </div>
                      );
                    })}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
